export default "/_next/static/images/6b7ccd14729845e2db96126e006f843c.jpg";